import { useState } from "react";
import { Pencil, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const nome = (c) => c.denominazione || `${c.nome || ""} ${c.cognome || ""}`.trim();
export const TIPI_CLIENTE = { tutti: "Tutti", privato: "Privato", azienda: "Azienda / professionista", pa: "Pubblica amministrazione", estero: "Estero" };
export const catCliente = (c) => (c.pa ? "pa" : c.nazione && c.nazione !== "IT" ? "estero" : c.piva ? "azienda" : "privato");
export const tipoCliente = (c) => (c ? TIPI_CLIENTE[catCliente(c)] : "-");

export const CustomerBox = ({ customer, parties, onPick, onNew, label, placeholder }) => {
  const [change, setChange] = useState(false);
  const picker = (
    <div className="flex gap-2">
      <Select value={customer?.id} onValueChange={(v) => { onPick(v); setChange(false); }}>
        <SelectTrigger data-testid="invoice-customer-select" className="min-w-0 bg-white"><SelectValue placeholder={placeholder} /></SelectTrigger>
        <SelectContent>{parties.map((c) => <SelectItem key={c.id} value={c.id}>{nome(c)}{c.nazione && c.nazione !== "IT" ? ` (${c.nazione})` : ""}</SelectItem>)}</SelectContent>
      </Select>
      <Button type="button" variant="outline" className="shrink-0 bg-white px-3" data-testid="invoice-new-customer-button" onClick={onNew}><UserPlus className="mr-1 h-4 w-4" />Nuovo</Button>
      {change && <Button type="button" variant="ghost" className="shrink-0 px-3" data-testid="cancel-change-customer-button" onClick={() => setChange(false)}>Annulla</Button>}
    </div>
  );
  if (!customer || change)
    return <div data-testid="customer-box"><div className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-slate-600">{label}</div>{picker}</div>;
  return (
    <div data-testid="customer-box" className="flex items-start justify-between gap-3">
      <div className="min-w-0 text-sm leading-relaxed text-slate-800">
        <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</div>
        {(customer.codice_destinatario || customer.pec) && <div className="text-xs text-slate-600">{customer.codice_destinatario ? `Codice destinatario: ${customer.codice_destinatario}` : `PEC: ${customer.pec}`}</div>}
        <div data-testid="customer-box-name" className="font-bold uppercase">{nome(customer)}</div>
        {customer.piva && <div>P.IVA: {customer.nazione || "IT"}{customer.piva}</div>}
        {customer.codice_fiscale && <div>C.F: {customer.codice_fiscale}</div>}
        {customer.indirizzo && <div>{customer.indirizzo}</div>}
        <div>{[customer.cap, customer.comune].filter(Boolean).join(" - ")}{customer.provincia ? ` (${customer.provincia})` : ""}</div>
      </div>
      <Button type="button" size="sm" variant="outline" className="shrink-0 bg-white" data-testid="change-customer-button" onClick={() => setChange(true)}><Pencil className="mr-1 h-3.5 w-3.5" />Cambia cliente</Button>
    </div>
  );
};
